// IELTS Mock 5 — Listening (IELTS Fever Listening Practice Test 8)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `chooseTwo` share one option list across two question numbers.
// Groups with `optionsBox` show a text box of lettered options instead of an image.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening5.mp3";

const IELTS_MOCK5_LISTENING = {
  title: "IELTS Listening Mock 5",
  sections: [
    {
      id: "s1",
      title: "Section 1: Transport from Bayswater",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 1–5: Complete the notes below. Write NO MORE THAN TWO WORDS AND/OR A NUMBER for each answer.",
          heading: "Transport from Bayswater",
          example: { q: "Destination: Harbour City" },
          image: null,
          questions: [
            { id: "q1", text: "Express train leaves at ______", type: "fill_blank", answer: ["9.30 a.m.", "9.30", "9.30 am", "9.30am"] },
            { id: "q2", text: "The ______ is the nearest station.", type: "fill_blank", answer: ["Helendale"] },
            { id: "q3", text: "Number 706 bus heads for ______", type: "fill_blank", answer: ["Central Street", "Central St"] },
            { id: "q4", text: "Number ______ bus goes to the station.", type: "fill_blank", answer: ["782"] },
            { id: "q5", text: "Earlier the bus leaves at ______", type: "fill_blank", answer: ["8.55 a.m.", "8.55", "8.55 am", "8.55am"] },
          ],
        },
        {
          instruction:
            "Questions 6–10: Complete the table below. Write ONE WORD AND/OR A NUMBER for each answer.",
          heading: "Fares",
          image: null,
          questions: [
            { id: "q6", text: "Bus — cash fare: $ ______ (card fare $1.50)", type: "fill_blank", answer: ["1.8", "1.80", "$1.80"] },
            { id: "q7", text: "Train (off-peak) — before 5 p.m. or after ______ p.m.", type: "fill_blank", answer: ["7.45", "7:45"] },
            { id: "q8", text: "Train (off-peak) — card fare: $ ______ (cash fare $10)", type: "fill_blank", answer: ["7.15", "$7.15"] },
            { id: "q9", text: "______ ferry (cash fare $4.50, card fare $3.55)", type: "fill_blank", answer: ["commuter"] },
            { id: "q10", text: "Tourist ferry (______) — cash fare $35", type: "fill_blank", answer: ["afternoon"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Advice on Saving Energy",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 11–16: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q11",
              text: "What was Jill surprised to find?",
              type: "mcq",
              options: [
                "A. Some work to reduce the water usage to her house could be done soon.",
                "B. The house was poorly insulated.",
                "C. She could get financial help.",
              ],
              answer: "A",
            },
            {
              id: "q12",
              text: "What does Jill say can be done straight away?",
              type: "mcq",
              options: [
                "A. Use energy-saving bulbs.",
                "B. Turn down the thermostat.",
                "C. Turn off their appliances completely.",
              ],
              answer: "C",
            },
            {
              id: "q13",
              text: "What pleased Jill about the energy provider?",
              type: "mcq",
              options: [
                "A. Reduction in price for prompt payment.",
                "B. Allowing customers to pay online.",
                "C. Having a reduction in price of the energy-saving sources.",
              ],
              answer: "B",
            },
            {
              id: "q14",
              text: "What difficulty does Jill have with the energy meters?",
              type: "mcq",
              options: [
                "A. They are difficult to access.",
                "B. The figures are hard to read accurately.",
                "C. She can't tell whether they're for electricity or for gas.",
              ],
              answer: "B",
            },
            {
              id: "q15",
              text: "What kind of energy-saving method is Jill going to take next?",
              type: "mcq",
              options: [
                "A. Use an energy-saving boiler.",
                "B. Have the walls checked for their insulation level.",
                "C. Install double-glazed windows.",
              ],
              answer: "C",
            },
            {
              id: "q16",
              text: "Why is Jill doubtful about renewable energy?",
              type: "mcq",
              options: [
                "A. She thinks it is unsuitable for her house.",
                "B. She doesn't understand the technical details.",
                "C. She believes that it's too expensive.",
              ],
              answer: "A",
            },
          ],
        },
        {
          instruction: "Questions 17–18: Choose TWO letters, A–E.",
          chooseTwo: true,
          question: "Which TWO water saving tips are not recommended by Jill?",
          options: [
            "A. Use more showers than baths.",
            "B. Keep the washing machine full before using it.",
            "C. Boil only as much water as you need.",
            "D. Turn off the taps while you are brushing your teeth.",
            "E. Repair leaking taps.",
          ],
          answer: ["A", "B"],
          questions: [{ id: "q17" }, { id: "q18" }],
        },
        {
          instruction: "Questions 19–20: Choose TWO letters, A–E.",
          chooseTwo: true,
          question: "Which TWO topics do people most frequently ask about?",
          options: [
            "A. The real temperature setting on the thermostat.",
            "B. Whether to leave the light on or not.",
            "C. Whether to use a computer or laptop to watch movies.",
            "D. How to work out the operating cost of appliances.",
            "E. Whether solar panels only work on sunny days.",
          ],
          answer: ["A", "C"],
          questions: [{ id: "q19" }, { id: "q20" }],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Talking about a Geography Assessment",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–25: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "Students may fail the exam if they",
              type: "mcq",
              options: [
                "A. Do not do a slideshow.",
                "B. Copy other people's work.",
                "C. Do not follow the instructions.",
              ],
              answer: "B",
            },
            {
              id: "q22",
              text: "Why does the man think they should skip some photos of the first volcano in the presentation?",
              type: "mcq",
              options: [
                "A. They are not attractive.",
                "B. There is not enough time.",
                "C. People have never heard of this.",
              ],
              answer: "A",
            },
            {
              id: "q23",
              text: "About Mount Fago, a volcano in Mexico or the USA, the man thinks",
              type: "mcq",
              options: [
                "A. They should not use inaccurate information in the presentation.",
                "B. They can find another example.",
                "C. It does not matter which volcano to use.",
              ],
              answer: "A",
            },
            {
              id: "q24",
              text: "The woman thinks they should mention Mount Etna since",
              type: "mcq",
              options: [
                "A. It covers most of the important points.",
                "B. It was formed a long time ago.",
                "C. It has amazing views.",
              ],
              answer: "C",
            },
            {
              id: "q25",
              text: "They reached an agreement to leave out Mount Herto since",
              type: "mcq",
              options: [
                "A. Other students have used it before.",
                "B. It is irrelevant to their topic.",
                "C. There is nothing special about this volcano.",
              ],
              answer: "B",
            },
          ],
        },
        {
          instruction:
            "Questions 26–30: Which statement can best fit each of the following situations? Choose FIVE answers from the box and write the correct letter, A–F, next to Questions 26–30.",
          heading: "Features",
          image: null,
          optionsBox: [
            "A. Make a short movie.",
            "B. Lack his / her own points.",
            "C. Ignore the positive sides.",
            "D. Watch some documentaries.",
            "E. Prepare beforehand.",
            "F. Identify the differences between them.",
          ],
          mapOptions: ["A", "B", "C", "D", "E", "F"],
          questions: [
            { id: "q26", text: "The woman's last presentation was criticised because it did", type: "map", answer: "B" },
            { id: "q27", text: "The tutor suggested for the next presentation the woman should", type: "map", answer: "A" },
            { id: "q28", text: "People do not know enough about volcanoes and so they", type: "map", answer: "C" },
            { id: "q29", text: "The reason why the man felt nervous is that he did not", type: "map", answer: "E" },
            { id: "q30", text: "They are researching active and extinct volcanoes to", type: "map", answer: "F" },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Birds in New Zealand",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 31–40: Complete the notes below. Write ONE WORD AND/OR A NUMBER for each answer.",
          heading: "Birds in New Zealand",
          image: null,
          questions: [
            { id: "q31", text: "Facts — The birds often build their nests along the coastline or beside the ______", type: "fill_blank", answer: ["river"] },
            { id: "q32", text: "Facts — In 1984, researchers suggested that there were only ______ of this kind of bird left.", type: "fill_blank", answer: ["3 pairs", "three pairs"] },
            { id: "q33", text: "Facts — It seems hard to ______ the number of birds precisely.", type: "fill_blank", answer: ["estimate"] },
            { id: "q34", text: "Influencing factors — Human activities, such as ______ as well as constructing homes threaten this bird.", type: "fill_blank", answer: ["farming"] },
            { id: "q35", text: "Population — The birds are influenced by many species which can eat their ______", type: "fill_blank", answer: ["eggs"] },
            { id: "q36", text: "Population — Natural disasters including ______ can also reduce the population of the birds.", type: "fill_blank", answer: ["storms"] },
            { id: "q37", text: "Ways of protection — The zoo should recruit a ______ to prevent the birds from being poached.", type: "fill_blank", answer: ["guard"] },
            { id: "q38", text: "Ways of protection — The organizer could build a ______ to prevent the public from getting closer.", type: "fill_blank", answer: ["fence"] },
            { id: "q39", text: "Ways of protection — People should make more of an effort to protect ______ birds.", type: "fill_blank", answer: ["wild"] },
            { id: "q40", text: "Ways of protection — Through the ______, people will know more about bird protection.", type: "fill_blank", answer: ["media"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK5_LISTENING;
